import { Fragment, memo, useState } from 'react';
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';
import { PmiHeadTableCell } from 'shell/components/shared/table-custom/head';
import CardRow from './table-row';
import { NotesTextItemVM } from 'civil-status/view-models/notes-text-list';

export interface TableIdCardComponentProps {
  items: Array<NotesTextItemVM>;
  onTrashPress: (item: NotesTextItemVM) => void;
  onVisibilityPress: (item: NotesTextItemVM) => void;
  onEditPress: (item: NotesTextItemVM) => void;
}

const TableIdCardComponent = ({
  items,
  onTrashPress,
  onVisibilityPress,
  onEditPress,
}: TableIdCardComponentProps) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const rowsPerPageOptions = [5, 10, 20, 50];

  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;

  return (
    <Fragment>
      <TableContainer>
        <Table sx={{ minWidth: 900 }} size="medium" stickyHeader aria-label="lista soggetti">
          <TableHead>
            <TableRow>
              <PmiHeadTableCell>Titolo</PmiHeadTableCell>
              <PmiHeadTableCell>Testo</PmiHeadTableCell>
              <PmiHeadTableCell>Tipo</PmiHeadTableCell>
              <PmiHeadTableCell>Azioni</PmiHeadTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(items || []).slice(startIndex, endIndex).map((card) => (
              <CardRow
                key={card.code}
                item={card}
                onTrashPress={onTrashPress}
                onVisibilityPress={onVisibilityPress}
                onEditPress={onEditPress}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={rowsPerPageOptions}
        component="div"
        labelRowsPerPage="Righe per pagina:"
        count={items.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(event: unknown, newPage: number) => setPage(newPage)}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
        }}
      />
    </Fragment>
  );
};

TableIdCardComponent.displayName = 'Table id card component';

const TableIdCard = memo(TableIdCardComponent);

export default TableIdCard;
